import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AccessibleHome from './pages/AccessibleHome';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AccessibleHome />} />
      </Routes>
    </Router>
  );
}

export default App;